import { useLeaseCompStore, useMapMarkerStore, usePipedriveStore } from "..";
import { showErrorToast, showSuccessToast } from "../components/ToastContainer";
import { ILeaseCompState } from "../interfaces/ILeaseComp";

const useLeaseCompCreate = (): (leaseCompState: ILeaseCompState, regridId: string | null) => Promise<number> => {
    const leaseCompStore = useLeaseCompStore();
    const pipedriveStore = usePipedriveStore();
    const mapMarkerStore = useMapMarkerStore();

    return async (leaseCompState: ILeaseCompState, regridId: string | null): Promise<number> => {
        try {
            const createdLeaseCompId = await leaseCompStore.createLeaseComp(
                leaseCompState,
                await pipedriveStore.getOrCreatePipedriveOrganizationId(leaseCompState.pipedriveCompanyName),
                mapMarkerStore.coordinates!,
                regridId
            );

            showSuccessToast();

            return createdLeaseCompId;
        } catch (e) {
            showErrorToast();
            throw e;
        }
    };
};

export default useLeaseCompCreate;